import {createEventBus} from '@malt/vue-event-bus/create-event-bus';

export type FreelancerSignupEvent = {
    'freelancer-signup-step:go-next': void;
    'freelancer-signup-step:go-to-first-step-to-complete': {save: boolean} | void;
    'freelancer-signup-step:go-to-signin': void;
    'freelancer-signup-step:go-to-welcome-back': void;
    'freelancer-signup-step:go-to-regular-workflow': void;
};

export const freelancerSignupEventBus = createEventBus<FreelancerSignupEvent>();
